import { getPriority } from '@esentai/core/features/productView/selectors';
import {
  compose,
  equals,
  head,
  last,
  map,
  max,
  min,
  not,
  pipe,
  reduce,
} from 'ramda';

import itemsDuck from './ducks/items';
import queryDuck from './ducks/query';

export const {
  getError,
  isLoadingItems,
  getItemsIds,
  getItemsMeta,
  getItemsTotalCount,
} = itemsDuck.selectors;

export const { getPage, getLimit, getQuery, getSort } = queryDuck.selectors;

export const isFirstPage = pipe(getPage, equals(0));

export const isLastPage = state => {
  const totalCount = getItemsTotalCount(state);
  const currentOffset = (getPage(state) + 1) * getLimit(state);

  return currentOffset > totalCount;
};

export const isFirstItem = (state, viewId) => {
  const ids = getItemsIds(state);
  const firstItem = head(ids);

  return viewId === firstItem;
};

export const isLastItem = (state, viewId) => {
  const ids = getItemsIds(state);
  const lastItem = last(ids);

  return viewId === lastItem;
};

export const getViewsPriorities = state =>
  pipe(
    getItemsIds,
    map(viewId => getPriority(state, viewId)),
  )(state);

export const getHighestPriority = pipe(
  getViewsPriorities,
  reduce(min, Infinity),
);

export const getLowestPriority = pipe(
  getViewsPriorities,
  reduce(max, -Infinity),
);

export const hasHighestPriority = (state, viewId) => {
  const priority = getPriority(state, viewId);
  const highestPriority = getHighestPriority(state);

  return priority === highestPriority;
};

export const hasLowestPriority = (state, viewId) => {
  const priority = getPriority(state, viewId);
  const lowestPriority = getLowestPriority(state);

  return priority === lowestPriority;
};

export const canMoveViewUp = compose(not, isFirstItem);

export const canMoveViewDown = compose(not, isLastItem);
